import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Route, Redirect, Switch, Link, useRouteMatch } from 'react-router-dom';
import { AppBar, Toolbar, Typography } from '@material-ui/core';
import { SignIn } from 'features/Auth/SignIn';
import { SignUp } from 'features/Auth/SignUp';
import { RecoverPassword } from 'features/Auth/RecoverPassword';
import { recoverPassword, signIn, signUp, productsPrefix } from 'routes/routes';
import { isUserAuthenticated } from 'features/Auth/auth';
import { Column } from 'components/UI/Column';
import logo from '../logo.png';

const AuthRoutes = () => {
  const match = useRouteMatch();
  const { t } = useTranslation();
  const isAuthenticated = useSelector(isUserAuthenticated);
  const titleStyle = {
    paddingLeft: '1em'
  };

  return (
    <>
      <AppBar position="sticky">
        <Toolbar className="navColor">
          <img src={logo} alt="Logo" height="32" width="32" />
          <Typography variant="h6" style={titleStyle}>
            Box-e
          </Typography>
        </Toolbar>
      </AppBar>
      <Switch>
        <Route exact path={`${match.path}`}>
          <Redirect to={`${match.path}${signIn}`} />
        </Route>
        <Route exact path={`${match.path}${signIn}`} component={SignIn}>
          {isAuthenticated && <Redirect to={productsPrefix} />}
        </Route>
        <Route path={`${match.path}${signUp}`} component={SignUp}>
          {isAuthenticated && <Redirect to={productsPrefix} />}
        </Route>
        <Route exact path={`${match.path}${recoverPassword}`} component={RecoverPassword}>
          {isAuthenticated && <Redirect to={productsPrefix} />}
        </Route>
        <Route
          path="*"
          component={() => (
            <Column justifyContent="center" alignItems="center">
              <h2>{t('errors.not found')}</h2>
              <Link to="/auth/signin">{t('label.back')}</Link>
            </Column>
          )}
        />
      </Switch>
    </>
  );
};

export { AuthRoutes };
